import React from 'react';

export function Badge({ status }) {
  return <span className={`badge ${status}`}>{status}</span>;
}

export function RoleChip({ role }) {
  const cls = role === 'trainer' ? 'role-chip tr' : 'role-chip';
  return <span className={cls}>{role}</span>;
}
